"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.PopoverContext = React.createContext({
    excludeClickOutsideClasses: [],
});
//# sourceMappingURL=PopoverContext.js.map